import React from "react";
import { Pill } from "../ui";

const EMAIL_STATUS = {
  waiting_connection: ["Ready to copy · Outlook not connected", "amber"],
  creating: ["Creating draft…", "sky"],
  drafted: ["In Outlook drafts", "green"],
  sending: ["Sending…", "sky"],
  sent: ["Sent", "green"],
  failed: ["Draft failed", "red"],
  handled: ["Sent by hand", "neutral"],
};
const APPROVAL_STATUS = { done: ["Approved", "green"], failed: ["Stopped · needs retry", "red"], running: ["Writing to Monday…", "sky"] };

export const STEP_ORDER = ["allocate", "w2_columns", "w2_group", "register", "emails"];

export const H = ({ children }) => <div className="text-[0.62rem] uppercase tracking-[0.16em] font-bold text-neutral-500 mb-2">{children}</div>;

export function EmailStatusPill({ status, testId }) {
  const [label, tone] = EMAIL_STATUS[status] || [status, "neutral"];
  return <Pill tone={tone} testId={testId}>{label}</Pill>;
}

export function ApprovalPill({ status, testId }) {
  const [label, tone] = APPROVAL_STATUS[status] || [status, "neutral"];
  return <Pill tone={tone} testId={testId}>{label}</Pill>;
}

export function TextBlock({ title, text, testId }) {
  return (
    <div data-testid={testId}>
      <H>{title}</H>
      <p className="text-xs text-neutral-300 whitespace-pre-wrap max-h-36 overflow-y-auto bg-black/30 border border-neutral-800 rounded-lg px-3 py-2">{text || "—"}</p>
    </div>
  );
}

export const htmlToText = (html) => {
  const d = document.createElement("div");
  d.innerHTML = (html || "").replace(/<\/td>\s*<td/gi, ": </td><td").replace(/<br\s*\/?>/gi, "\n").replace(/<\/(p|tr|table)>/gi, "\n\n");
  return d.textContent.replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
};

export async function copyRich(html) {
  const text = htmlToText(html);
  try {
    await navigator.clipboard.write([new window.ClipboardItem({ "text/html": new Blob([html], { type: "text/html" }), "text/plain": new Blob([text], { type: "text/plain" }) })]);
  } catch {
    await navigator.clipboard.writeText(text);
  }
}
